import React from "react";
import { ForgotPassword } from "../../_metronic/layout/components/signIn/ForgotPassword";

export const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};
